export const ageOfConsentMap: { [key: string]: number } = {
  AT: 14,
  BE: 13,
  CZ: 15,
  DK: 13,
  ES: 14,
  FI: 15,
  FR: 15,
  GB: 13,
  IE: 16,
  NO: 13,
  PL: 13,
  SE: 13,
  ROW: 16,
};
